/* import __COLOCATED_TEMPLATE__ from './add-mcp-actions-modal.hbs'; */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import { get, post } from 'embercom/lib/ajax';
import { type TaskGenerator } from 'ember-concurrency';
import { getIconForMcpServer } from '../../models/workflow-connector/constants/mcp-templates';

interface Args {
  onModalClose: () => void;
  mcpServerId: string | null;
  mcpServerName: string | null;
}

export default class AddMcpActionsModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare router: $TSFixMe;
  @service declare intercomEventService: any;

  @tracked mcpServerTools = [];

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    taskFor(this.fetchMcpServerTools).perform();
  }

  get serverIcon(): string {
    return getIconForMcpServer(this.args.mcpServerName ?? '');
  }

  getToolDisplayName(toolName: string): string {
    return toolName
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  trackAction(actionName: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: actionName,
      object: 'mcp_action',
    });
  }

  @task({ drop: true })
  *fetchMcpServerTools(): TaskGenerator<void> {
    try {
      let response = yield get(
        '/ember/workflow_connector/setup_mcp_actions/list_mcp_server_tools',
        {
          app_id: this.appService.app.id,
          mcp_server_id: this.args.mcpServerId,
        },
      );
      this.mcpServerTools = response.tools;
    } catch (error) {
      console.error('Error fetching MCP server tools:', error);
    }
  }

  @task({ drop: true })
  *createMcpAction(tool: any): TaskGenerator<void> {
    this.trackAction('mcp_action_creation_attempt');

    try {
      yield post('/ember/workflow_connector/setup_mcp_actions/create_mcp_action', {
        app_id: this.appService.app.id,
        mcp_server_id: this.args.mcpServerId,
        tool,
      });

      this.trackAction('mcp_action_creation_success');
      window.location.reload();
    } catch (error) {
      console.error('Error adding MCP server:', error);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::AddMcpActionsModal': typeof AddMcpActionsModal;
    'workflow-connector/add-mcp-actions-modal': typeof AddMcpActionsModal;
  }
}
